/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useApiStatus from "../../../../../hooks/useApiStatus";
import ExtraPayService from "../../../../../service/ExtraPayService";

const useConversionList = ({ onError }) => {
  const service = new ExtraPayService(localStorage.getItem("__extraconomy_token"));
  const {
    isLoading,
    hasError,
    isSuccess,
    setIsLoading,
    setIsSuccess,
    setHasError,
    retryFetch,
    setRetryFetch,
  } = useApiStatus({ isLoading: true });

  const [conversions, setConversions] = useState([]);

  const getConversions = () => {
    setIsLoading(true);
    service
      .getConversionsByUser(localStorage.getItem("__extraconomy_username"))
      .then((response) => {
        if (response.messageCode !== 200001) {
          onError(response.messageCode);
          setHasError(true);
          return;
        }
        setConversions(response.result);
        setIsSuccess(true);
      })
      .catch((error) => {
        setHasError(true);
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getConversions();
    return () => {
      setIsLoading();
      setIsSuccess();
      setHasError();
    };
  }, []);

  useEffect(() => {
    if (retryFetch) {
      getConversions();
      setRetryFetch(false);
    }
  }, [retryFetch]);

  return {
    conversions,
    isLoading,
    hasError,
    isSuccess,
    retryFetch,
    setRetryFetch,
  };
};

export default useConversionList;
